import axios from 'axios';
import { bootstrapSessionFromLocal, getStoredToken, rememberPostLoginRedirect, removeToken } from '../utils/authStorage';
import { getUserFriendlyErrorMessage } from '../utils/errorMessages';

/** CRA injects REACT_APP_API_URL; if unset, browser calls the dev server (3000) and /integrations/* returns 404. */
function resolveApiBaseUrl(): string {
    const raw = process.env.REACT_APP_API_URL;
    if (typeof raw === 'string' && raw.trim()) {
        return raw.trim().replace(/\/$/, '');
    }
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn(
            '[axios] REACT_APP_API_URL is unset; using http://localhost:8000. Use npm run start:dev or set REACT_APP_API_URL in .env.local.',
        );
        return 'http://localhost:8000';
    }
    return '';
}

const api = axios.create({
    baseURL: resolveApiBaseUrl(),
    headers: {
        'Content-Type': 'application/json',
    },
});

bootstrapSessionFromLocal();

// Add request interceptor for auth token
api.interceptors.request.use((config) => {
    const token = getStoredToken();

    const isAuthFreeEndpoint = [
        '/auth/send-mobile-otp',
        '/auth/send-email-otp',
        '/auth/verify-email',
        '/auth/login',
        '/auth/register',
        '/auth/google-login'
    ].some((path) => config.url?.includes(path));

    if (token && config.headers && !isAuthFreeEndpoint) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});


// Add response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error && typeof error === 'object') {
            error.userMessage = getUserFriendlyErrorMessage(error);
        }
        if (error.response?.status === 401) {
            // Handle unauthorized access
            rememberPostLoginRedirect(window.location.pathname + window.location.search);
            removeToken();
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default api;
